import React from "react";
import { HotelDetails } from "../../../assets/Services/wsSearch";
import {
  Map,
  AdvancedMarker,
  APIProvider,
  CollisionBehavior,
} from "@vis.gl/react-google-maps";
import IconStructure from "../../../assets/icons/IconStructure";

type Props = {
  hotel: HotelDetails;
};

export default function DetailMap({ hotel }: Props) {
  // This is a workaround to make the map rerender when having a new search
  return (
    <APIProvider apiKey={String(process.env.REACT_APP_GOOGLE_API_KEY)}>
      <Map
        // this is a workaround to avoid the map to be rerendered when navigating
        className={`w-full h-full z-10`}
        mapId="RESULTS_MAP"
        fullscreenControl={false}
        mapTypeControl={false}
        streetViewControl={false}
        gestureHandling={"greedy"}
        defaultCenter={{
          lat: hotel.mongoDbLocation.coordinates[1],
          lng: hotel.mongoDbLocation.coordinates[0],
        }}
        defaultZoom={15}
        maxZoom={15}
        minZoom={10}
      >
        <AdvancedMarker
          position={{
            lat: hotel.mongoDbLocation.coordinates[1],
            lng: hotel.mongoDbLocation.coordinates[0],
          }}
          collisionBehavior={CollisionBehavior.REQUIRED}
        >
          <div className="custom-pin">
            <div className="flex items-center justify-center rounded-full bg-black size-[2.375rem]">
              <IconStructure className="size-5 stroke-white" />
            </div>
          </div>
        </AdvancedMarker>
      </Map>
    </APIProvider>
  );
}
